module.exports = __webpack_public_path__ + "static/media/devices.7a13dcb9.svg";